import { render } from "./insurance_data.vue?vue&type=template&id=2c742564&scoped=true"
import script from "./insurance_data.vue?vue&type=script&lang=js"
export * from "./insurance_data.vue?vue&type=script&lang=js"

import "./insurance_data.vue?vue&type=style&index=0&id=2c742564&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c742564"]])

export default __exports__